module.exports = __webpack_public_path__ + "img/bun-top.3912bba0.svg";